import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Separator, Text} from '@/src/ui';

import css from '../styles/AcademicTitleWidgetLayout.module.css';

interface AcademicTitleWidgetLayoutProps {
  prefixedAcademicTitle?: string | null;
  suffixedAcademicTitle?: string | null;
  onEditClick: (...args: any[]) => any;
}

const AcademicTitleWidgetLayout = ({
  prefixedAcademicTitle,
  suffixedAcademicTitle,
  onEditClick,
}: AcademicTitleWidgetLayoutProps) => {
  const isPrefixedTitleFilled = Boolean(prefixedAcademicTitle);
  const isSuffixedTitleFilled = Boolean(suffixedAcademicTitle);

  return (
    <>
      <div className={css.widget}>
        <div className={css.leftWidgetPart}>
          <div className={css.leftWidgetPartBlock}>
            {isPrefixedTitleFilled && (
              <Text
                fontSize={Text.FONT_SIZE.SIZE_16}
                fontWeight={Text.FONT_WEIGHT.BOLD}
                color={Text.COLOR.PRIMARY}
              >
                {prefixedAcademicTitle}
              </Text>
            )}
            <Text
              fontSize={Text.FONT_SIZE.SIZE_16}
              fontWeight={
                !isPrefixedTitleFilled
                  ? Text.FONT_WEIGHT.BOLD
                  : Text.FONT_WEIGHT.NORMAL
              }
              color={
                !isPrefixedTitleFilled ? Text.COLOR.PRIMARY : Text.COLOR.GREY
              }
            >
              <TextLocal id={'sing-up-add-info.prefixed-academic-title'} />
            </Text>
          </div>
          <div className={css.leftWidgetPartBlock}>
            {isSuffixedTitleFilled && (
              <Text
                fontSize={Text.FONT_SIZE.SIZE_16}
                fontWeight={Text.FONT_WEIGHT.BOLD}
                color={Text.COLOR.PRIMARY}
              >
                {suffixedAcademicTitle}
              </Text>
            )}
            <Text
              fontSize={Text.FONT_SIZE.SIZE_16}
              fontWeight={
                !isSuffixedTitleFilled
                  ? Text.FONT_WEIGHT.BOLD
                  : Text.FONT_WEIGHT.NORMAL
              }
              color={
                !isSuffixedTitleFilled ? Text.COLOR.PRIMARY : Text.COLOR.GREY
              }
            >
              <TextLocal id={'sing-up-add-info.suffixed-academic-title'} />
            </Text>
          </div>
        </div>
        <div className={css.rightWidgetPart}>
          <Button
            color={Button.COLOR.SECONDARY}
            height={Button.HEIGHT.SMALL}
            border={Button.BORDER.BOLD}
            onClick={onEditClick}
          >
            <TextLocal id={'profile.edit'} />
          </Button>
        </div>
      </div>
      <div className={css.separatorBlock}>
        <Separator borderWeight={Separator.BORDER_WEIGHT.THIN} />
      </div>
    </>
  );
};

export default AcademicTitleWidgetLayout;
